<template>
	<fragment>
		<common-header
			subname="설문 관리"
			name="설문문항 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus" :btnList="sideButtons"></common-side-menu>
			<!-- //end .side-nav -->

			<div class="container-fiuld class-making-box clearfix" v-if="selectedSurvey">
				<div class="title-box b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">{{selectedSurvey.surveyName}}</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">설문자</p>
					<div class="input-group full-width">
						<span class="input-group-addon w180 p-r-5">
							<input class="form-control round m-b-0" type="text" placeholder="이름" v-model="surveyResult.mberName">
						</span>
						<span class="input-group-addon">
							<input class="form-control text-left round m-b-0" type="text" placeholder="전화번호" v-model="surveyResult.mobileNum">
						</span>
					</div>
				</div>

				<div class="white-box clearfix" v-for="(surveyItem, idx) in selectedSurvey.surveyItemMappingList" :key="`survey-itme-${hash(surveyItem)}`">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">{{idx + 1}}.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ {{ surveyItem.type }} ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							{{ surveyItem.itemName }}
						</span>
					</div>

					<template v-if="surveyItem.type === '주관식'">
						<div class="col-md-12">
                            <textarea class="full-width v-mid" cols="30" rows="6" @blur="setTextAnswer(surveyItem, $event)"></textarea>
						</div>
					</template>
					<template v-else>
						<div class="col-md-12">
							<div class="input-group full-width m-b-10" v-for="answer in surveyItem.child" :key="`survey-itme-${hash(surveyItem)}-child-${hash(answer)}`">
								<span class="input-group-addon w60 v-mid p-r-5">
									<input :id="`survey-itme-${hash(surveyItem)}-child-${hash(answer)}`" class="checkbox4" type="checkbox" @change="setAnswer(answer)">
									<label :for="`survey-itme-${hash(surveyItem)}-child-${hash(answer)}`" class="sq">체크버튼</label>
								</span>
								<span class="input-group-addon text-left v-mid p-r-5" style="line-height: 1">
									{{ answer.itemName }}
								</span>
								<span class="input-group-addon text-left v-mid p-r-5" v-if="answer.type === '작성보기'">
                                    <input class="form-control-sm full-width text-left round m-b-0" type="text" @blur="setTextAnswer(answer,  $event)">
								</span>
							</div>
						</div>
					</template>
				</div>
				<div class="b-t p-15 p-l-0 p-r-0 m-t-30 m-b-30 clearfix">
					<button class="btn round w160 pull-right" @click="putSurvey">저장</button>
				</div>
			</div>
		</section>

        <transition name="fade" v-if="isSurveyEnd">
            <div id="out-modal" class="modal-box" style="display: block;">
                <div class="modal modal-sm alert">
                    <div class="modal-header p-0 clearfix">
                        <a class="close" @click="endSurvey">×</a>
                    </div>

                    <div class="modal-body p-10 clearfix">
                        <button class="btn lg-btn half-width center-block round m-t-30 m-b-15" @click="newSurvey">이어서 등록</button>
                        <button class="btn lg-btn half-width center-block round m-b-30" @click="endSurvey">등록 마침</button>
                    </div>
                </div>
            </div>
        </transition>

		<modal-survey-answer :config="modals.ModalSurveyAnswer" @close="modals.ModalSurveyAnswer.show=false;" :key="hash(modals.ModalSurveyAnswer)"></modal-survey-answer>
		<modal-survey-register
			:config="modals.ModalSurveyRegister"
			:key="'modal-survey-register-'+hash(modals.ModalSurveyRegister)"
			@close="modals.ModalSurveyRegister.show=false;"
			@refresh="refreshData()"></modal-survey-register>
		<modal-survey-register-excel :config="modals.ModalSurveyRegisterExcel" @close="modals.ModalSurveyRegisterExcel.show=false;" :key="'modal-survey-register-excel-'+hash(modals.ModalSurveyRegisterExcel)"></modal-survey-register-excel>
		<modal-confirm :config="modals.ModalConfirm" @yes="removeCancleItem()" @no="removeItem()" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import ModalSurveyRegister from '../modals/ModalSurveyRegister.vue'
import ModalSurveyRegisterExcel from '../modals/ModalSurveyRegisterExcel.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalSurveyAnswer from '../modals/ModalSurveyAnswer.vue'
import Axios from 'axios'
import server from '../statics/server'

export default {
	name: "ViewSurveyRegi",
	mixins: [fnAdjustHeight],
	components: {
		CommonHeader,
		CommonSideMenu,
		ModalSurveyRegister,
		ModalSurveyRegisterExcel,
		ModalConfirm,
		ModalAlert,
		ModalSurveyAnswer
	},
	mounted: function() {
		this.getSurveyList()
	},
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'설문문항 관리',link:"/surveys",selected:false},
				{name:'설문 분류',link:"/surveys/categories",selected:false},
				{name:'설문 통계',link:"/surveys/statistics",selected:true},
			],
			buttons: [
				{name: '설문문항 등록', fn: () => {
					this.openNewSurveyModal();
				}},
				{name: '설문문항 일괄등록', fn: () => {
					this.openNewSurveyExcelModal();
				}},
			], // 헤더버튼
			sideButtons: [],
			sideMenus: [],
			modals: {
				ModalSurveyAnswer: ModalSurveyAnswer.default(),
				ModalSurveyRegister: ModalSurveyRegister.default(),
				ModalSurveyRegisterExcel: ModalSurveyRegisterExcel.default(),
				ModalAlert: ModalAlert.default(),
				ModalConfirm: ModalConfirm.default(),
			}, // 모달 설정객체 모음
			selectedSurvey: null,
            answerList: null,
            surveyResult: {
                surveyId: this.$route.params.surveyId,
                mberName: "",
                mobileNum: "",
                surveyItemApplList: [
                    // {surveyItemId:보기번호}, // 객관식 문항에 type='보기'인 아이템을 선택한 경우
                    // {surveyItemId:보기번호, etcText:문자열}, // 객관식 문항에 type='작성보기'인 아이템을 선택한 경우
                    // {surveyItemId:문항번호, etcText:문자열} // 주관식 문항에 답변을 입력한 경우
                ]
            },
            isSurveyEnd: false
		}
	},
	methods: {
		openNewSurveyModal: function() {
			this.modals.ModalSurveyRegister.show = true;
		},
		openNewSurveyExcelModal: function() {
			this.modals.ModalSurveyRegisterExcel.show = true;
		},
		// 설문지 목록을 sidemenu에 출력해주는 함수
		getSurveyList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.SURVEY}`, { });
				this.sideMenus = data.list.map( (e) => {
                    if(e.surveyId == this.$route.params.surveyId) this.selectedSurvey = e;
					return {
                        selected: e.surveyId == this.$route.params.surveyId,
						name: e.surveyName,
						fn: this.setSurvey(e)
					};
                });
			} catch (e) {
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = "통신 오류입니다. 잠시 후 다시 시도해주세요.";
			}
		},
		setSurvey: function(survey) {
			survey;
			return async () => {
                this.$router.push(`/surveys/statistics/`)
			}
        },
        setAnswer: function(answer) {
            const answerIndex = this.surveyResult.surveyItemApplList.findIndex(e=>e.surveyItemId === answer.surveyItemId);

            if(answerIndex === -1) {
                this.surveyResult.surveyItemApplList.push({surveyItemId: answer.surveyItemId});
            } else {
                this.surveyResult.surveyItemApplList.splice(answerIndex, 1);
            }
        },
        setTextAnswer: function(answer, $event) {
            const answerIndex = this.surveyResult.surveyItemApplList.findIndex(e=>e.surveyItemId === answer.surveyItemId);

            if(answerIndex === -1) {
                this.surveyResult.surveyItemApplList.push({surveyItemId: answer.surveyItemId, etcText: $event.target.value});
            } else {
                this.surveyResult.surveyItemApplList[answerIndex]['etcText'] = $event.target.value;
            }
        },
        putSurvey:async function() {
            try {
				await Axios.put(`${server.addr()}${server.api.SURVEY_APPL}`, [this.surveyResult]);
                this.isSurveyEnd = true;
            } catch(e) {
                this.modals.ModalAlert.msg="등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
                this.modals.ModalAlert.show=true;
            }
        },
        newSurvey: async function() {
            location.reload()
        },
        endSurvey: async function() {
            this.$router.push('/surveys/statistics/');
        }
	}
}
</script>

<style>

</style>